import { FC } from "react";
import { ButtonProps, Stack, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import GreyAddButton from "src/Pages/Company/Dashboard/components/GreyAddButton";

const AddNewUrlButton: FC<ButtonProps> = (props) => (
  <Stack
    sx={{ width: "fit-content", textAlign: "center" }}
    data-testid="add-new-url-button"
  >
    <GreyAddButton {...props} />
    <Typography variant="body2" data-testid="add-new-url-button__label">
      {__("Dodaj link")}
    </Typography>
  </Stack>
);

export default AddNewUrlButton;
